import type { RouteRecordRaw } from 'vue-router'
import { routes } from '@app/router/routes'

export const bankAccountsRoutes: RouteRecordRaw[] = [
  {
    path: routes.BANK_ACCOUNTS,
    name: 'BANK_ACCOUNTS',
    component: () => import('./BankAccountsPage.vue'),
    meta: { requiresAuth: true },
  },
  {
    // Legacy deep-link — redirects to /bank-accounts?action=add so the drawer
    // pre-opens. Kept so existing links / emails don't break.
    path: routes.ADD_BANK_ACCOUNT,
    name: 'ADD_BANK_ACCOUNT',
    redirect: { path: routes.BANK_ACCOUNTS, query: { action: 'add' } },
    meta: { requiresAuth: true },
  },
  {
    // Legacy deep-link — redirects to /bank-accounts?id=:id so the details
    // drawer pre-opens. Kept so existing links / emails don't break.
    path: routes.BANK_ACCOUNT_DETAIL,
    name: 'BANK_ACCOUNT_DETAIL',
    redirect: (to) => ({ path: routes.BANK_ACCOUNTS, query: { id: to.params.id as string } }),
    meta: { requiresAuth: true },
  },
]
